import { getView, requireAuth } from '@/lib/utils';
import {
  AssetAnalyticsPage,
  AssetDetailsPage,
  AssetTimelinePage,
  AssetChemicalsPage,
  AssetMaterialsPage,
  PageAssetEdit,
} from '@/data/appInformationItems';
import { Left } from 'Models/Menu/menus';

export default {
  path: '/assets/:_key([0-9]+)',
  name: 'asset',
  component: getView('pages/PageAsset'),
  redirect: { name: 'asset-analytics' },
  meta: {
    roles: ['operator'],
  },
  children: [
    {
      path: 'timeline',
      name: 'asset-timeline',
      component: getView('assets/TabTimeline'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Timeline',
        leftMenu: Left.AssetTimeline,
        information: AssetTimelinePage,
        showBottomMenu: true,
      },
    },
    {
      path: 'location',
      name: 'asset-location',
      component: getView('assets/TabLocation'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Location',
        leftMenu: Left.AssetDetails,
        information: AssetDetailsPage,
        showBottomMenu: false,
      },
    },
    {
      path: 'analytics',
      name: 'asset-analytics',
      component: getView('assets/TabAnalytics'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Analytics',
        leftMenu: Left.AssetAnalytics,
        information: AssetAnalyticsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'data',
      name: 'asset-data-points',
      component: getView('assets/TabData'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Data',
        leftMenu: Left.AssetDetails,
      },
    },
    {
      path: 'details',
      name: 'asset-details',
      component: getView('assets/TabDetails'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Details',
        leftMenu: Left.AssetDetails,
      },
    },
    {
      path: 'dosing',
      name: 'asset-dosing',
      component: getView('assets/TabDosing'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Dosing',
        leftMenu: Left.AssetDetails,
        information: AssetDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'alerts',
      name: 'asset-alerts',
      component: getView('assets/TabAlerts'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Alerts',
        leftMenu: Left.AssetDetails,
        information: AssetDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'chemicals',
      name: 'asset-chemicals',
      component: getView('assets/TabChemicals'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Chemicals',
        leftMenu: Left.AssetChemicals,
        information: AssetChemicalsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'assign-chemical',
      name: 'assetChemicalAssign',
      component: getView('pages/PageAssetChemicalEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Chemicals > Assign',
        leftMenu: Left.AssetsList,
        information: AssetChemicalsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'materials',
      name: 'asset-materials',
      component: getView('assets/TabMaterials'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Materials',
        leftMenu: Left.AssetMaterials,
        information: AssetMaterialsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'settings',
      name: 'asset-settings',
      component: getView('assets/TabSettings'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Settings',
        leftMenu: Left.AssetAnalytics,
        information: AssetAnalyticsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'assign-material',
      name: 'assetMaterialAssign',
      component: getView('pages/PageAssetMaterials'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Materials > Assign',
        leftMenu: Left.AssetsList,
        information: AssetMaterialsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'files',
      name: 'asset-files',
      component: getView('assets/TabFiles'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Files',
        leftMenu: Left.AssetFiles,
        information: AssetDetailsPage,
        showBottomMenu: true,
      },
    },
    {
      path: 'edit',
      name: 'assetEdit',
      component: getView('pages/PageAssetEdit'),
      beforeEnter: requireAuth,
      meta: {
        crumbs: 'Assets > Edit',
        leftMenu: Left.AssetsList,
        information: PageAssetEdit,
        showBottomMenu: true,
      },
    },
  ],
};
